import React from "react";
import { Redirect } from "react-router-dom";
import AdminNavigation from "../components/admin/AdminNavigation";
import QueryLoading from "../components/animations/QueryLoading";
import useAxios from "axios-hooks";
import { API_URL } from "../config";

const AdminPage = ({ userData, userLoading }) => {
  const [
    { data: allUsers, loading: allUsersLoading },
    fetchAllUsers,
  ] = useAxios({
    url: `${API_URL}/getAllUsers`,
    method: "GET",
    withCredentials: true,
  });
  const [{ data: courses, loading: coursesLoading }] = useAxios({
    url: `${API_URL}/getCoursesFromDB`,
    method: "GET",
    withCredentials: true,
  });
  if (userLoading || allUsersLoading || coursesLoading) {
    return <QueryLoading />;
  }

  if (userData.admin) {
    return (
      <AdminNavigation
        allUsers={allUsers}
        courses={courses}
        fetchAllUsers={fetchAllUsers}
      />
    );
  }
  return <Redirect to="/login" />;
};

export default AdminPage;
